export default {
  state: {
    isColumnMatchingDrawerOpen: false,
    typeMatching: "", // questionnaire || enrichment
    responseParsing: null,
    responseParsingOriginal: null,
    vendorDocIdSelected: null,
    selectedTabMatching: null,
  },
  mutations: {
    SET_IS_COLUMN_MATCHING_DRAWER_OPEN(state, payload) {
      console.log("Inside SET_IS_COLUMN_MATCHING_DRAWER_OPEN", payload);
      state.isColumnMatchingDrawerOpen = payload;
    },
    SET_TYPE_MATCHING(state, payload) {
      console.log("Inside SET_TYPE_MATCHING", payload);
      state.typeMatching = payload;
    },
    SET_VENDOR_DOC_ID_SELECTED(state, payload) {
      console.log("Inside SET_VENDOR_DOC_ID_SELECTED", payload);
      state.vendorDocIdSelected = payload;
    },
    SET_RESPONSE_PARSING(state, payload) {
      console.log("Inside SET_RESPONSE_PARSING", payload);
      state.responseParsing = payload;
    },
    SET_RESPONSE_PARSING_ORIGINAL(state, payload) {
      console.log("Inside SET_RESPONSE_PARSING_ORIGINAL", payload);
      state.responseParsingOriginal = payload;
    },
    SET_SELECTED_TAB_MATCHING(state, payload) {
      console.log("Inside SET_SELECTED_TAB_MATCHING", payload);
      state.selectedTabMatching = payload;
    },
  },
  getters: {
    GET_IS_COLUMN_MATCHING_DRAWER_OPEN(state) {
      return state.isColumnMatchingDrawerOpen;
    },
    GET_TYPE_MATCHING(state) {
      return state.typeMatching;
    },
    GET_VENDOR_DOC_ID_SELECTED(state) {
      return state.vendorDocIdSelected;
    },
    GET_RESPONSE_PARSING(state) {
      return state.responseParsing;
    },
    GET_RESPONSE_PARSING_ORIGINAL(state) {
      return state.responseParsingOriginal;
    },
    GET_SELECTED_TAB_MATCHING(state) {
      return state.selectedTabMatching;
    },
  },
};
